const ITEMS = [
  "The classroom stays real",
  "AuraXR adds another dimension",
  "See it. Explore it. Understand it.",
  "Making understanding visible",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/[0.06] bg-[#050811] py-5 select-none"
    >
      <div className="animate-aura-marquee flex w-max items-center gap-12 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-12">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-12">
                <span className="font-display italic text-lg sm:text-xl text-slate-500">{t}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#38BDF8]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
